"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapCursorToMax = function (cursor, max) {
    if (max === 0)
        return 0;
    if (cursor >= 0)
        return cursor % max;
    var modulo = cursor % max;
    if (modulo === 0)
        return Math.abs(modulo); // -0
    return modulo + max;
};
